import { render, staticRenderFns } from "./dialog-snackbermultidownload-new.vue?vue&type=template&id=4b06b610&scoped=true&"
import script from "./dialog-snackbermultidownload-new.vue?vue&type=script&lang=js&"
export * from "./dialog-snackbermultidownload-new.vue?vue&type=script&lang=js&"
import style0 from "./dialog-snackbermultidownload-new.vue?vue&type=style&index=0&id=4b06b610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b06b610",
  null
  
)

export default component.exports